import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Title from './../tools/Title';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import app from '../base/api';
import * as _ from 'lodash';
import { useNavigate } from 'react-router-dom';

class ListBase extends React.Component {

  constructor () {
    super();
    this.state = {fetchRows: [], cls: '', columns: [], search: '', rows: []};
    this.title = '';
  }

  componentDidMount ()  {
    this.fetchData();
  }

  fetchData = async () => {
    let rows = await app.get(`/api/tables/${this.state.cls}/`);
    this.setState({fetchRows: rows, rows: rows})
  }

  showRow = async (params) => {
    this.props.navigate(`/dashboard/${this.state.cls}/${params.row.id}`);
  }

  normalize (s) {
    if (!s) return s;
    if (s.normalize != undefined) {
        s = s.normalize ("NFKD");
    }
    s = s.toString().replace(/æ/g, "ae");
    s = s.replace(/[\'`´]/g, "");
    s = s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return s.replace(/[\u0300-\u036F]/g, "");
  }

  filterRows (rows, search) {
    let columns = _.map(this.state.columns, (r) => r.field);
    if (search) {
      let values = search.split(' ')
      return _.filter(rows, (r) => {
        for (let value of values){
          let found = false;
          let re = new RegExp(this.normalize(value), 'i')
          for (let f of columns) {
            let m = this.normalize(r[f]).match(re)
            if (m) found = true;
          }
          if (!found) return false;
        }
        return true;
      })
    }
    return rows;
  }

  newRecord = async (params) => {
    this.props.navigate(`/dashboard/${this.state.cls}/new`);
  }

  handleChange = (event, value) => {
    let search = event.target.value;
    let rows = this.filterRows(this.state.fetchRows, search);
    this.setState({
      rows: rows,
    });
  }

  render () {
      return (
        <React.Fragment>
          <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Title>{this.title}</Title>
            <Grid container spacing={2}>
              <Grid key='Buscar' item xs={12}><TextField
                margin="normal"
                key='Buscar'
                fullWidth
                type='text'
                id='Buscar'
                value={this.state.search}
                onChange={this.handleChange}
                label='Buscar'
              /></Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <Paper
                  sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    height: 400,
                  }}
                >
                <div style={{ height: 400, width: '100%' }}>
                  <DataGrid
                    key="ListTable"
                    rows={this.state.rows}
                    columns={this.state.columns}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    onCellClick={this.showRow}
                  />
                </div>
                </Paper>
              </Grid>
            </Grid>
            <Button
              type="button"
              onClick={this.newRecord}
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Nuevo
            </Button>

          </Container>

        </React.Fragment>
      );
  }
}

// Wrapper component to provide navigate to ListBase
function ListBaseWithNavigate(props) {
  const navigate = useNavigate();
  return <ListBase {...props} navigate={navigate} />;
}

export { ListBase };
export default ListBaseWithNavigate;